// dev
// stripe = Stripe 'pk_znR9dUa0sPXSlVv2009vpWdtexnnq'
// CHECKOUT_API = "https://x09r00vyqe.execute-api.us-east-1.amazonaws.com/dev"

// prod

API_KEY := 'pk_PPCRZgLrovwFHSKmMkjtVONHDs3pR'
CHECKOUT_API := "https://api.danielx.net"
productId := 1

{ Modal } from @danielx/dui

result := window.location.search.match /^\?checkout_session_id=(.*)/

if result
  checkoutId := result[1]

  Modal.alert """
    Thank you for your purchase! Check your email for the download links and a link that unlocks this web version.
  """

let loadingPromise: Promise<unknown>?
stripe .= null

export loadStripe := ->
  unless loadingPromise
    loadingPromise = new Promise<void> (resolve, reject) ->
      script := document.createElement 'script'
      script.onload = ->
        stripe = Stripe API_KEY
        resolve()
      script.onerror = (e) ->
        loadingPromise = undefined
        reject(e)
      script.src = "https://js.stripe.com/v3/"

      document.body.appendChild script

  return loadingPromise

// Create a session on stripe checkout, then redirect to it with
// the session id
// Eventually there will be more product ids, but right now they are
// all Paint Composer
// When the checkout is compeleted stripe hits the stripe-webhook lambda
// which sends the user an email with links to download.
export purchase := ->
  Promise.all([
    loadStripe()
    fetch(`${CHECKOUT_API}/purchases/${productId}`)
  ])
  .then ([s, r]) -> r.json()
  .then (data) ->
    console.log data

    return data.id
  .then (sessionId) ->
    stripe.redirectToCheckout
      sessionId: sessionId
    .then (result) ->
      if result.error?
        console.error result.error
  .catch (e) ->
    console.error e
    Modal.alert """
      I AM ERROR
    """
